module.exports = "/_next/static/images/Anthony_Byfield-c21310161dcc13aa589c40907f26923e.webp";